/// <reference path="../../_ext/editors/ItemGridEditor.ts" />
namespace TabAurous.Sales {

    import fld = ApprovalOutReturnItemsRow.Fields;

    @Serenity.Decorators.registerClass()
    export class ApprovalOutReturnItemsEditor extends _Ext.ItemGridEditor<ApprovalOutReturnItemsRow> {

        protected getColumnsKey() { return "Sales.ApprovalOutReturnItems"; }
        protected getDialogType() { return ApprovalOutReturnItemsDialog; }
        protected getLocalTextPrefix() { return ApprovalOutReturnItemsRow.localTextPrefix; }
        protected form: ApprovalOutReturnItemsForm;

        public pendingChanges: Q.Dictionary<any> = {};

        // #region Variables
        public PartyId: number;
        public RateListId: number;
        public LaborListId: number;
        public StoneMarkup: number;
        public LaborMarkup: number;
        public ExchangeRate: number;

        //validate pieces and weight on new creation
        //public pieces = [];
        //public weight = [];
        //public itemids = [];
        //public isUpdate: number;
        //public canUpdate: number;
        // #endregion

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as ApprovalOutReturnDialog).CalculateAmountandTax(this.view.getItems() );
                }
            });

        }

        // #region Column Add -Remove
        protected getColumns() {
            var columns = super.getColumns();
            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Pieces).format = int;
            var wt = ctx => ColumnFormatter.WeightFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.Weight).format = wt;

            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });

            return columns;
        }

        // #endregion 
        //#region  ItemGrid Inline Editor
        // **** Delete event handler ****
        //protected onClick(e: JQueryEventObject, row: number, cell: number) {
        //    super.onClick(e, row, cell);


        //    if (e.isDefaultPrevented())
        //        return;

        //    var item = this.itemAt(row);
        //    //To Set Master Product Image
        //    ApprovalOutReturnDialog.image = item.ImageName;
        //    var target = $(e.target);

        //    // if user clicks "i" element, e.g. icon
        //    if (target.parent().hasClass('inline-action'))
        //        target = target.parent();

        //    if (target.hasClass('inline-action')) {
        //        e.preventDefault();

        //        if (target.hasClass('delete-row')) {
        //            Q.confirm('This will effect Stock and can not be undone, Are you sure want to delete? ', () => {

        //                var id = this.id(item); 
        //                this.view.deleteItem(id); 
        //            });

        //            this.view.refresh();
        //        }

        //        if (target.hasClass('edit numeric')) {
        //            super.onClick(e, row, cell);
        //        }
        //    }
        //    if (target.hasClass('edit numeric')) {
        //        e.preventDefault();

        //        if (target.hasClass('edit numeric')) {
        //            // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
        //            //TODO: Need to add System Parameter to enable disable blocking
        //            var input = $(e.target);
        //            if (input != undefined) {
        //                if (this.canUpdate == 0) {
        //                    //Check Editable
        //                    target.addClass('readonly');
        //                    target.blur();
        //                    Q.alert("Readonly Detected")

        //                }
        //                else if (this.canUpdate == 1) {
        //                    target.removeClass('readonly');
        //                    var input = $(e.target);
        //                    var y = input.data();
        //                    if (y.field == "Weight" && item.ItemTypeId == 101) {
        //                        target.addClass('readonly');
        //                        target.blur();
        //                    }
        //                    else if (y.field == "Pieces" && item.ItemTypeId == 104) {
        //                        target.addClass('readonly');
        //                        target.blur();
        //                    }
        //                }
        //                //else if (y.field == "Pieces" && item.CalcOnId == 5) {
        //                //    target.addClass('readonly');
        //                //    target.blur();
        //                //}
        //                //else if (y.field == "Weight" && item.CalcOnId == 3) {
        //                //    target.addClass('readonly');
        //                //    target.blur();
        //                //}
        //            }

        //            this.view.refresh();
        //        }
        //    }
        //}

        //Row Edit Event handler
        private inputsChange(e: JQueryEventObject,) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            // *** Format Number ***
            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            let _value = ValidateEditorFields(field, input, text, oldText);
            let value: number;
            if (q.isNumber(_value))
                value = parseFloat(_value.toString());
            else
                return false;

 
            let oldvalues: ApprovalOutRow;
            Stock.StockItemService.GetReturnValues({
                ProductId: item.ProductId,
                Line_No: item.Line_No,
                SKU: item.SKU,
                BagNo: item.BagNo,
                PartyId: item.PartyId,
                VoucherTypeId: 34,
                RefVoucherTypeId:32
            },
                response =>
                    oldvalues = response.Entity,
                { async: false });

            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Pieces && value > 0) {
                var oldpieces = oldvalues.Pieces;

                if (value > oldpieces) {
                    Q.alert('Invalid Pieces value');
                    item[field] = oldpieces;
                } else {
                    if (item.CalcOnId == 3) {
                        item.GrossAmount = item.UnitRate * value;
                        item.NetAmount = item.UnitRate * value;
                        item.GrossAmount = item.NetAmount * value;
                        item.Weight = (item.Weight / item.Pieces) * value;
                        item.DiamondPieces = (item.DiamondPieces / item.Pieces) * value;
                        item.DiamondWeight = (item.DiamondWeight / item.Pieces) * value;
                        item.DiamondAmount = (item.DiamondAmount / item.Pieces) * value;
                        item.StonePieces = (item.StonePieces / item.Pieces) * value;
                        item.StoneWeight = (item.StoneWeight / item.Pieces) * value;
                        item.StoneAmount = (item.StoneAmount / item.Pieces) * value;
                        item.OtherPieces = (item.OtherPieces / item.Pieces) * value;
                        item.OtherWeight = (item.OtherWeight / item.Pieces) * value;
                        item.OtherAmount = (item.OtherAmount / item.Pieces) * value;
                        item.NetWeight = (item.NetWeight / item.Pieces) * value;
                        if (item.WstPer != null) {
                            item.WstWt = item.NetWeight * (item.WstPer / 100);
                        }
                        item[field] = value;

                        this.view.updateItem(id, item);
                        this.view.refresh();
                    }
                }

            }
            // *** Update Weight, Amount etc on Pieces Change***
            if (field === fld.Weight && value > 0) {

                var oldweight = oldvalues.Weight;
                if (value > oldweight) {
                    var labr = item.UnitLabour || 0;
                    var rate = item.UnitRate || 0;
                    if (item.ItemTypeId == 101 || item.ItemTypeId == 104) {
                        rate = item.UnitRate * item.Purity;
                    }

                    var Net = (rate + labr) * value;
                    item.NetAmount = Net;
                    var Discount = Net * (item.DiscountPer / 100) || 0;
                    item.Discount = Discount
                    item.GrossAmount = Net - Discount;
                    item.NetWeight = value;
                    if (item.WstPer != null) {
                        item.WstWt = value * (item.WstPer / 100);
                    }
                    item[field] = value;
                    this.view.updateItem(id, item);
                    this.view.refresh();
                }

            }
            // *** Calculate Wastage ***
            if (field === fld.WstPer && value >= 0) {
                item.WstWt = item.NetWeight * (value / 100);
                item[field] = value;
            }

            // *** Calculate Discount ***
            if (field === fld.Discount && value >= 0) {
                item.GrossAmount = item.NetAmount - value;
                item[field] = value;

            }

            // *** Set Department ***
            if (field === fld.DepartmentId && value > 0) {
                item[field] = value;

            }

            this.view.updateItem(id, item);
            this.view.refresh();
            (this.parentDialog as ApprovalOutReturnDialog).CalculateAmountandTax(this.view.getItems() );


            let returnvalue: string = "";
            if (input.hasClass('numeric'))
                returnvalue = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                returnvalue = Q.formatNumber(value, '0');

            input.val(returnvalue).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }
            return item[field];
        }

        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }

        // #endregion


        // #region Buttons Add-Remove
        protected getButtons() {
            let buttons = super.getButtons();
            buttons = buttons.filter(x => x.cssClass != "add-button");

            // *** Add Select Button to Grid Editor ***
            buttons.push({
                title: "Select Products",
                cssClass: "add-button",
                hotkey: "Alt+K",
                onClick: () => {
                    var grid = SalesApprovalItemsGrid;
                    // **** Validate Party before Item Selection ****
                    if (isNaN(this.PartyId)) {
                        Q.notifyWarning("Please select Supplier to proceed");
                        return;

                    }
                    else {
                        var filters: _Ext.SelectGridFilters = {
                            PartyId: this.PartyId,
                            InStock: true
                        }
                        var pickerDialog = new _Ext.GridItemPickerDialog({
                            gridType: grid, multiple: true, title: "Select Items",
                            preSelectedKeys: this.value.map(k => k.ProductId), GridFilters: filters
                        });
                    }


                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.TransItemId == t.TransItemId) });

                        var ItemDetails = ItemGridHelper.SetReturnItemGrid(selectedItems2);

                        for (let Item of ItemDetails) {
                            Item[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Item;
                            this.view.addItem(Item);
                        }
                    }
                    pickerDialog.dialogOpen();
                }
            });

            return buttons;
        }
        // #endregion

    }
}